import React from 'react'

const CoreComponent8 = ({corecontent}) => {
  return (
     <div className="d-flex align-items-center flex-wrap">
          {corecontent.map((val, i) => (
            <div
              className="row d-flex  align-items-center justify-content-center"
              key={i}
            >
              <div
                className="col-lg-6 col-11 mx-auto bg-black pt-40 pb-40 ps-4 pe-2 mb-4 mb-lg-0"
                
              >
                <h2 className="h2-heading text-start fs-2 mb-3 lh-sm text-white">{val.title}</h2>
                <h3 className="h3-heading fs-4 mb-2 pb-1 text-white">{val.subtitle}</h3>
                <p className='h3-para h1-para lh-base  text-white'>{val.desc}</p>
              </div>
              <div className="col-lg-6 col-11 mx-auto bg-light shadow py-4 ps-30 pe-30 d-flex align-items-center justify-content-center flex-column " >
                {val.icons.map((item, j) => (
                  <div className="row ps-3 pe-2 mb-4 " key={j} >
                    <div className="d-flex align-items-center justify-content-start ">
                      <div
                        className="bg-white me-1 d-flex flex-column border  align-items-center justify-content-center  rounded-circle"
                        style={{ width: 35, height: 35 }}
                      >
                        <img className="m-0 w-75 " src={item.icon} alt="" />
                      </div>
                      <h3 className="h3-heading text-start fs-5 ms-2">{item.icontitle}</h3>
                    </div>
                    <p className="h3-para fs-6 lh-sm pt-1">{item.icondesc}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
  )
}

export default CoreComponent8